/** Espelha OrdemProducaoEstoqueExcluirRequest do OrquestradorSuprimentos: exclusão do estoque da OP. */
export class OrdemProducaoEstoqueExcluirRequest {
  /** Motivo da exclusão, de 10 a 500 caracteres. */
  justificativa = '';
}
